<page-headline
    *ngIf="!routerModule"
    [module]="'report-menu'"
    [moduleIcon]="'fa-table'"
    [pageTitle]="'Reports'"
>
</page-headline>

<page-headline
    *ngIf="routerModule"
    [module]="'report-menu'"
    [moduleIcon]="'fa-table'"
    [pageTitle]="'Reports'"
    [linkTitle]="getRouterModuleName()"
    [moduleLink]="routerModule"
>
</page-headline>

<ng-template #template let-anchor>
    <span>
        {{ anchor.nativeElement.getAttribute('full-text') || anchor.nativeElement.innerText }}
    </span>
</ng-template>
<div class="report-menu-search-container">
    <div class="report-menu-search-area">
        <mat-form-field fluid appearance="outline" class="example-full-width">
            <mat-label>Search Reports</mat-label>
            <input
                matInput
                [(ngModel)]="search"
                id="icon-button-2"
                outlined
                (ngModelChange)="updateGrid()"
            />
            <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
    </div>
</div>
<div
    kendoTooltip
    showOn="none"
    [tooltipTemplate]="template"
    tooltipClass="tooltip-style"
    (mouseover)="showTooltip($event)"
>
    <div class="row-layout-track-left-align">
        <div class="largecard-layout-box__30pct">
            <div id="reportSelector">
                <div id="reportSelectorHeader">
                    <span>Module</span>
                    <span style="float: right">#</span>
                </div>
                <ng-container *ngIf="doneLoadingModules">
                    <div
                        class="reportSelectorItem"
                        *ngFor="let item of modules"
                        [ngClass]="{
                            reportSelectorItemCurrent: item.selected,
                            reportSelectorItemUnderline: item.name == 'Bookmarked Reports'
                        }"
                        (click)="selectItem(item)"
                    >
                        <span>{{ item.name }}</span>
                        <span style="float: right">{{ item.count }}</span>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="largecard-layout-box__70pct">
            <kendo-grid
                #grid="kendoGrid"
                [data]="gridView"
                [pageSize]="pageSize"
                [skip]="skip"
                (cellClick)="cellClickHandler($event)"
                [sortable]="sortable"
                [sort]="sort"
                (sortChange)="sortChange($event)"
                [pageable]="pageable"
                [scrollable]="false"
                (pageChange)="pageChange($event)"
            >
                <kendo-grid-column
                    field="bookmarked"
                    title=""
                    [headerClass]="'reports-header'"
                    [headerStyle]="{
                        'text-align': 'left',
                        'background-color': '#223540',
                        color: '#FFFFFF',
                        'border-color': '#223540'
                    }"
                    width="75"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <i *ngIf="dataItem.bookmarked" class="fas fa-bookmark report-bookmark"></i>
                        <i *ngIf="!dataItem.bookmarked" class="far fa-bookmark report-bookmark"></i>
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column
                    field="moduleName"
                    title="MODULE"
                    [headerClass]="'reports-header'"
                    [headerStyle]="{
                        'text-align': 'left',
                        'background-color': '#223540',
                        color: '#FFFFFF',
                        'border-color': '#223540'
                    }"
                    width="200"
                >
                    <ng-template kendoGridCellTemplate let-dataItem>
                        <i class="fas" [ngClass]="getReportModuleIcon(dataItem)"></i>
                        &nbsp;
                        {{ dataItem.moduleName }}
                    </ng-template>
                </kendo-grid-column>

                <kendo-grid-column
                    field="name"
                    title="NAME"
                    [headerClass]="'reports-header'"
                    [headerStyle]="{
                        'text-align': 'left',
                        'background-color': '#223540',
                        color: '#FFFFFF',
                        'border-color': '#223540'
                    }"
                    width="250"
                >
                </kendo-grid-column>

                <kendo-grid-column
                    field="description"
                    title="DESCRIPTION"
                    [headerClass]="'reports-header'"
                    [headerStyle]="{
                        'text-align': 'left',
                        'background-color': '#223540',
                        color: '#FFFFFF',
                        'border-color': '#223540'
                    }"
                >
                    <ng-template kendoGridCellTemplate let-record>
                        <div
                            *ngIf="record.description"
                            class="truncate"
                            [attr.full-text]="record.description"
                        >
                            {{ record.description | truncateToChars: 170 }}
                        </div>
                    </ng-template>
                </kendo-grid-column>

                <ng-template kendoPagerTemplate>
                    <kendo-pager-prev-buttons class="text-color-black"></kendo-pager-prev-buttons>
                    <kendo-pager-input class="text-color-black"></kendo-pager-input>
                    <kendo-pager-info class="text-color-black"></kendo-pager-info>
                    <kendo-pager-next-buttons class="text-color-black"></kendo-pager-next-buttons>
                    <kendo-pager-page-sizes
                        class="text-color-black"
                        [pageSizes]="[10, 25, 50, 100]"
                    ></kendo-pager-page-sizes>
                </ng-template>
            </kendo-grid>
        </div>
    </div>
</div>
